import './won-offer-list.scss';
import { useMemo } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ClbLoading } from '@celebration/react';
import { useTranslation } from 'react-i18next';
import WonOfferCard from '../won-offer-card/won-offer-card';
import IWonOfferResponse from '../../../../../common/interfaces/offers/IWonOfferResponse';
import { useOffersWon } from '../../../../../app/contexts/offers-won/offers-won.context';
import IWonOfferListProps from './IWonOfferListProps';

function WonOfferList({ filters }: Readonly<IWonOfferListProps>) {
    const { t } = useTranslation();
    const { wonOffersList, hasMore, fetchNextPage, updateWonOffer } =
        useOffersWon();

    const loadListEndMessage = useMemo(() => {
        if (wonOffersList.length > 0) {
            return <h2>{t('SmartCargas.WonOffers.AllOffers')}</h2>;
        }

        return <h2>{t('SmartCargas.WonOffers.EmptyList')}</h2>;
    }, [wonOffersList.length, t]);

    return (
        <div data-testid="won-offer-infinite-scroll">
            <InfiniteScroll
                className="won-offer-list"
                dataLength={wonOffersList.length}
                next={() => {
                    fetchNextPage(filters.current);
                }}
                hasMore={hasMore.current}
                loader={<ClbLoading />}
                endMessage={loadListEndMessage}
            >
                {wonOffersList.length > 0 &&
                    wonOffersList.map((item: IWonOfferResponse) => {
                        return (
                            <WonOfferCard
                                key={item.offerId}
                                wonOffer={item}
                                updateOffer={updateWonOffer}
                            />
                        );
                    })}
            </InfiniteScroll>
        </div>
    );
}

export default WonOfferList;
